import { Body, Button, H5, Stack, useTheme } from '@qred/components-library';
import React from 'react';
import { ApplicationEvaluationOutcome } from '~/enums';
import useTranslate from '~/hooks/useTranslate';
import {
  GoldenRatioContainer,
  StandardPageContainer,
} from '~/styles/BaseStyledComponents';

type ImgConfig = {
  src: string;
  dimensions: {
    width: number;
    height: number;
  };
};

const RESULT_IMG: Record<ApplicationEvaluationOutcome, ImgConfig> = {
  [ApplicationEvaluationOutcome.Approve]: {
    src: '/auto_decision_approved.svg',
    dimensions: { width: 240, height: 240 },
  },
  [ApplicationEvaluationOutcome.ManualReview]: {
    src: '/auto_decision_manual.svg',
    dimensions: { width: 240, height: 240 },
  },
  [ApplicationEvaluationOutcome.Reject]: {
    src: '/auto_decision_rejected.svg',
    dimensions: { width: 180, height: 180 },
  },
};

export const CardApplicationResult = ({
  status,
  clientId,
}: {
  status: ApplicationEvaluationOutcome;
  clientId: number;
}) => {
  const theme = useTheme();
  const t = useTranslate();

  const offerUrl = `${globalThis.location.origin}/card-offer/${clientId}`;

  const titleKey = {
    [ApplicationEvaluationOutcome.Approve]:
      'Onboarding.AutoProcessingApprovedTitle',
    [ApplicationEvaluationOutcome.ManualReview]:
      'Onboarding.AutoProcessingManualReviewTitle',
    [ApplicationEvaluationOutcome.Reject]:
      'Onboarding.AutoProcessingRejectedTitle',
  }[status];

  const descriptionKey = {
    [ApplicationEvaluationOutcome.Approve]:
      'Onboarding.AutoProcessingApprovedDescription',
    [ApplicationEvaluationOutcome.ManualReview]:
      'Onboarding.AutoProcessingManualReviewDescription',
    [ApplicationEvaluationOutcome.Reject]:
      'Onboarding.AutoProcessingRejectedDescription',
  }[status];

  const title = t(titleKey) as string;
  const description = t(descriptionKey);
  const img = RESULT_IMG[status];

  return (
    <StandardPageContainer
      style={{
        backgroundColor: theme.fn.themeColor('Container/Option_2_(White)'),
        maxWidth: '600px',
        padding: `0 ${theme.spacing.xxl}`,
        margin: '0 auto',
      }}
      data-testid="card_application_result_page"
    >
      <GoldenRatioContainer style={{ width: '100%' }}>
        <Stack align="center" spacing="xxl">
          <img
            src={img.src}
            alt={title}
            style={{
              width: `${img.dimensions.width}px`,
              height: `${img.dimensions.height}px`,
            }}
          />
          <H5 color="Text/Headlines_(Brand)">{title}</H5>
          <Body size="lg" color="Text/Secondary">
            {description}
          </Body>
          {status === ApplicationEvaluationOutcome.Approve && (
            <a href={offerUrl} target="_blank" rel="noopener noreferrer">
              <Button fullWidth size="md" rightIcon="open_in_new">
                {t('CreditCardTermsAndConditionsCard.IdentifyButtonText')}
              </Button>
            </a>
          )}
        </Stack>
      </GoldenRatioContainer>
    </StandardPageContainer>
  );
};
